module.exports = __webpack_public_path__ + "static/img/IMG_20240629_172811.b17a26b5.jpg";